import React, {lazy} from "react";
import {Route, Routes, Navigate} from "react-router-dom";
import {Footer} from "views/components/Footer/footer.component";
import {retryFailLoad} from "data/utils";
import {PrivateRoute} from "views/components/route";
import {HOCi18n} from "views/components/HOCi18n";
import {Header} from "views/components/Header";
import {HOCMain} from "views/components/HOCMain/HOCMain.component";
import {HelpLayout} from "views/components/Layout/HelpLayout";

const Home = lazy(retryFailLoad(() => import("views/pages/landing/landing.page")));
const Picks = lazy(retryFailLoad(() => import("views/pages/picks/picks.page")));
const Leagues = lazy(retryFailLoad(() => import("views/pages/leagues/my_leagues/my_leagues.page")));
const Prizes = lazy(retryFailLoad(() => import("views/pages/prizes/prizes.page")));
const Terms = lazy(retryFailLoad(() => import("views/pages/help/terms.page")));
const FAQs = lazy(retryFailLoad(() => import("views/pages/help/faq.page")));
const ContactUs = lazy(retryFailLoad(() => import("views/pages/help/contactUs.page")));
const Guidelines = lazy(retryFailLoad(() => import("views/pages/help/guidelines.page")));
const NotFound = lazy(retryFailLoad(() => import("views/pages/not_found/not_found.page")));
const LeagueCreatePage = lazy(() => import("views/pages/leagues/create/league_create.page"));
const LeaguesOutlet = lazy(retryFailLoad(() => import("views/pages/leagues/leagues.outlet")));
const LeaguesJoinPage = lazy(
	retryFailLoad(() => import("views/pages/leagues/join/leagues_join.page"))
);
const Leaderboard = lazy(retryFailLoad(() => import("views/pages/leaderboard/leaderboard.page")));
const ViewLeagueOutlet = lazy(() => import("views/pages/league/viewLeague.outlet"));
const LeagueLadderPage = lazy(() => import("views/pages/league/league_ladder/leagueLadder.page"));
const LeagueInvitesPage = lazy(
	() => import("views/pages/league/league_invites/league_invites.page")
);
const AboutLeague = lazy(() => import("views/pages/league/league_about/leagueAbout.page"));
const ManageLeague = lazy(() => import("views/pages/league/league_manage/leagueManage.page"));
const Profile = lazy(() => import("views/pages/profile/profile.page"));
const InvitePage = lazy(() => import("views/pages/invite/invite.page"));

export const RootRoutes: React.FC = () => (
	<React.Fragment>
		<HOCi18n>
			<HOCMain>
				<Header />
				<Routes>
					<Route index element={<Home />} />
					<Route path="/my-picks" element={<Picks />} />
					<Route element={<PrivateRoute />}>
						<Route path="/leagues" element={<LeaguesOutlet />}>
							<Route path="" element={<Leagues />} />
							<Route path="join" element={<LeaguesJoinPage />} />
							<Route path="create" element={<LeagueCreatePage />} />
						</Route>
						<Route path="league/:id">
							<Route element={<ViewLeagueOutlet />}>
								<Route path="rankings" element={<LeagueLadderPage />} />
								<Route path="invites" element={<LeagueInvitesPage />} />
								<Route path="about" element={<AboutLeague />} />
							</Route>
							<Route path="manage" element={<ManageLeague />} />
						</Route>
						<Route path="/rankings" element={<Leaderboard />} />
						<Route path="/profile" element={<Profile />} />
					</Route>
					<Route path="invite/:code" element={<InvitePage />} />
					<Route path="/prizes" element={<Prizes />} />
					<Route path="/help" element={<HelpLayout />}>
						<Route index element={<Navigate to="terms" />} />
						<Route path="terms" element={<Terms />} />
						<Route path="faq" element={<FAQs />} />
						<Route path="contact" element={<ContactUs />} />
						<Route path="guidelines" element={<Guidelines />} />
						<Route path="*" element={<Navigate to="terms" />} />
					</Route>
					<Route path="*" element={<NotFound />} />
				</Routes>
				<Footer />
			</HOCMain>
		</HOCi18n>
	</React.Fragment>
);

export default RootRoutes;
